import $ from 'jquery';

export default class Select {
  constructor(instance) {
    this.$el = $(instance.el);
    this.$el.on('change.select', () => this.updateSelectText());
    this.$el.on('blur.select', () => this.blurSelect());
    this.$el.on('focus.select', () => this.focusSelect());

    if (!this.$el.parent('.select-wrapper').length && !this.$el.hasClass('product-select')) {
      this.$el.wrap("<div class='select-wrapper' />").parent().prepend("<span class='selected-text'></span>");
    }

    this.updateSelectText();
  }

  blurSelect() {
    this.$el.parent('.select-wrapper').toggleClass('active', false);
  }

  focusSelect() {
    this.$el.parent('.select-wrapper').toggleClass('active', true);
  }

  updateSelectText() {
    const newOption = this.$el[0].querySelector('option:checked');
    const optionText = newOption ? newOption.innerHTML : '';

    if (this.$el.siblings('.selected-option').length) {
      this.$el.siblings('.selected-option').text(optionText);
    } else {
      this.$el.siblings('.selected-text').text(optionText);
    }
  }

  unload() {
    this.$el.off('.select');
  }
}
